// extracted by mini-css-extract-plugin
export default {"wrapper":"YkbuRz","icons":"G6GNlz","withIcons":"bLcQyE","user":"K0sbQf","name":"ukB2Bd","arrowWrapper":"zhlV_J","arrow":"m11Au3","nativeMenu":"Tmx_Fq","greetingText":"Vc2GM7"};